import { FC } from "react";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { CostType, ProviderType } from "@/services/cloudchipr.api";
import { CostTypeSelectItemProviders } from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/CostTypeSelectItemProviders";
import { getTitleByCostTypeAndProvider } from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/utils/constants";

interface CostTypeSelectItemProps {
  label: string;
  value: string;
  providers: ProviderType[];
  workFor?: Extract<ProviderType, "aws" | "azure">;
}

export const CostTypeSelectItem: FC<CostTypeSelectItemProps> = ({
  label,
  value,
  workFor,
  providers,
}) => {
  const displayLabel = getTitleByCostTypeAndProvider(
    label,
    value as CostType,
    workFor,
  );

  return (
    <Stack direction="row" spacing={1}>
      <Typography>{displayLabel}</Typography>
      {!workFor && <CostTypeSelectItemProviders providers={providers} />}
    </Stack>
  );
};
